import "core-js/stable";
import "regenerator-runtime/runtime";
import "isomorphic-fetch";
import ReactDOM from "react-dom";
import RouteWrap from "./Route";
import * as serviceWorker from "./serviceWorker";
import "antd/dist/antd.css";
import "./antd-custom.css";

const faUrl = process.env.REACT_APP_FA_CSS_URL;

if (faUrl) {
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = faUrl;
  document.head.appendChild(link);
}

ReactDOM.render(<RouteWrap />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
